import { IJBPMAP } from '../../../models/IJBPPMAP'
import { EMPTY_MAP_PLACEHOLDER, PLANNING_BY_FY_FQ } from '../../config'

import { getMapValue } from './getMapValue'

interface IIsMapDataPresent {
  mapData: IJBPMAP[]
  fy: number
  category: string
  subCategory: string
  l3Category: string
  isUnits: boolean
}

export const isMapDataPresent = (props: IIsMapDataPresent): boolean => {
  let isDataPresent = false

  const quarters = [PLANNING_BY_FY_FQ, 1, 2, 3, 4]

  quarters.forEach((fq) => {
    const val = getMapValue({ ...props, fq })
    if (val !== EMPTY_MAP_PLACEHOLDER) {
      isDataPresent = true
    }
  })
  let val = getMapValue({ ...props, fq: PLANNING_BY_FY_FQ, fy: props.fy + 1 })
  if (val !== EMPTY_MAP_PLACEHOLDER) {
    isDataPresent = true
  }
  val = getMapValue({ ...props, fq: PLANNING_BY_FY_FQ, fy: props.fy + 2 })
  if (val !== EMPTY_MAP_PLACEHOLDER) {
    isDataPresent = true
  }

  return isDataPresent
}
